interface SubmissionCardProps {
  id: string;
  businessName: string;
  linesOfCoverage: string[];
  daysInStage: number;
  assignedAgent?: { name: string; avatarUrl?: string };
  completeness: number;
  onClick?: () => void;
}

const LOB_LABELS: Record<string, string> = {
  gl_bop: 'GL',
  wc: 'WC',
  auto: 'Auto',
  prof_cyber: 'E&O',
  dando: 'D&O',
  epli: 'EPLI',
  umbrella: 'Umb',
};

const LOB_COLORS: Record<string, string> = {
  gl_bop: 'bg-blue-100 text-blue-700',
  wc: 'bg-red-100 text-red-700',
  auto: 'bg-orange-100 text-orange-700',
  prof_cyber: 'bg-emerald-100 text-emerald-700',
  dando: 'bg-purple-100 text-purple-700',
  epli: 'bg-pink-100 text-pink-700',
  umbrella: 'bg-slate-100 text-slate-700',
};

export function SubmissionCard({
  businessName,
  linesOfCoverage,
  daysInStage,
  assignedAgent,
  completeness,
  onClick,
}: SubmissionCardProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="block w-full rounded-lg border border-slate-200 bg-white p-3 text-left shadow-sm transition hover:border-blue-300 hover:shadow-md"
    >
      <div className="flex items-start justify-between gap-2 mb-2">
        <div className="font-medium text-slate-900 line-clamp-2">{businessName}</div>
        <div
          className={`shrink-0 text-xs ${daysInStage > 3 ? 'text-orange-600 font-medium' : 'text-slate-500'}`}
        >
          {daysInStage}d
        </div>
      </div>

      <div className="flex flex-wrap gap-1 mb-3">
        {linesOfCoverage.map((lob) => (
          <span
            key={lob}
            className={`inline-block rounded px-1.5 py-0.5 text-[10px] font-semibold uppercase ${LOB_COLORS[lob] ?? 'bg-slate-100 text-slate-700'}`}
          >
            {LOB_LABELS[lob] ?? lob}
          </span>
        ))}
      </div>

      <div className="flex items-center justify-between">
        {assignedAgent ? (
          <div className="flex items-center gap-2">
            <div className="h-6 w-6 rounded-full bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center text-white text-xs font-medium">
              {assignedAgent.name.charAt(0)}
            </div>
            <span className="text-xs text-slate-600">{assignedAgent.name}</span>
          </div>
        ) : (
          <span className="text-xs text-slate-400 italic">Unassigned</span>
        )}

        <div className="flex items-center gap-1">
          <div className="h-1.5 w-12 overflow-hidden rounded-full bg-slate-100">
            <div
              className={`h-full ${completeness >= 80 ? 'bg-emerald-500' : completeness >= 50 ? 'bg-blue-500' : 'bg-orange-500'}`}
              style={{ width: `${completeness}%` }}
            />
          </div>
          <span className="text-xs text-slate-500">{completeness}%</span>
        </div>
      </div>
    </button>
  );
}
